import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDprOutput = {
  namespaced: true,

  state: {
    name: 'dpr-output',
    dprOutputs: []
  },

  mutations,
  getters,
  actions
}

export default moduleDprOutput;